import Image from "next/image"
import styles from "./tnpsc-group-II-mains-test-series.module.css";
import group2amaintest from "../../assets/images/Tnpsc/TNPSC-GrII-Mains-WebBanner.jpg";
import Mobbanner from "../../assets/images/Tnpsc/TNPSC-GrII-Mains-MobBanner.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Head from "next/head";
import Link from "next/link";
const Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper2 = () => {

     const feestructure3 =[

    // {center: "AnnaNagar",
    //    mode: (<div className="row"><div className="col-12 mb-2"> <div className="">Batch 2 <br/>(Online / Offline)</div></div></div>),
    //   start: (<div className="row"><div className="col-12 mb-2"> <div className="">27-12-2025  </div></div></div>),
    //     fee: (<><div>₹10,000 (For  Offline  Students)</div> <div>₹12,000 (For Online Students)</div> </>),
    //   cont3: (<div className="row"><div className="col-12  mb-2">
    //           <Link
    //             href="https://www.shankariasacademy.com/pdf/Tnpsc-GRP-II-Mains-TestSeries-2025/AnnaNagar/Tnpsc-GRP-II-Mains-B2-2025.pdf"
    //             target="_blank"
    //             className={`${styles.paybill}`}
    //           >
    //             Click here 
    //           </Link>
    //         </div>
    //       </div>
    //     )
    //   },

   
  

    ]
   

    return (
        <>
        <Head>
            <meta charset="UTF-8" />
            <link rel="icon" href="/logo.png" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index,follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title> TNPSC Group II Mains Test Series 2025 | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Group II Mains Test Series 2025 | Shankar IAS Academy" />
            <meta name="description" content="Prepare for TNPSC Group II Mains Test Series 2025 with expert-curated mock exams and detailed solutions to boost your preparation and ace the exam." />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-ii-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group II Mains Test Series 2025 | Shankar IAS Academy" />
            <meta property="og:description" content="Prepare for TNPSC Group II Mains Test Series 2025 with expert-curated mock exams and detailed solutions to boost your preparation and ace the exam." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-ii-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>
        <Navbar title="tnpsc" />

        <div className="container">

            <div className="row">
                <div className="col pt-3 pt-md-3">
                    <h1 className={`${styles.pagemaintitle}`}>TNPSC Group II Mains Test Series 2025</h1>
                </div>
            </div>

         <div className="row d-none d-md-block">
                <div className="col pt-2 mb-3">
                    <Image src={group2amaintest} alt="tnpsc-group-II-mains-test-series banner 2025" title="TNPSC Group II/II-A Mains 2024 New Test Series 2025" className="img-fluid w-100" />
                </div>
            </div>

            <div className="row  d-block d-md-none">
                <div className="col pt-2 mb-3">
                    <Image src={Mobbanner} alt="tnpsc-group-II-mains-test-series banner 2025" title="TNPSC Group II/II-A Mains 2024 New Test Series 2025" className="img-fluid w-100" />
                </div>
            </div>  

            {/* <div className="row pt-2">
                <div className="col-md-9 col-12">
                    <h2 className={`${styles.sectiontitle} mb-0`}>TNPSC Group II Mains 2024 New Test Series Paper II</h2>
                </div>

                 <div className="col">
                <Link href="/tnpsc-mains-test-series" ><button className={`${styles.normalbutton1} mt-2 mt-md-0`} type="submit">TNPSC Group II/II-A Mains Paper I </button></Link>
                </div>
            </div> */}

        </div>

    <section id="courseandfees">
        <div className="container pt-xl-4">
            {/* Desktop / Tablet View */}
            <div className="row d-none d-md-block">
                <div className="col">
                    <div className={`${styles.tablescroll}`}>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th className={`${styles.tableheading}`} style={{ backgroundColor: "#7f0801" , color: "#fff" }}>Center</th>
                                    <th className={`${styles.tableheading}`} style={{ backgroundColor: "#7f0801" , color: "#fff" }}>Batch / Mode</th>
                                    <th className={`${styles.tableheading}`} style={{ backgroundColor: "#7f0801" , color: "#fff" }}>Starts on</th>
                                    <th className={`${styles.tableheading}`} style={{ backgroundColor: "#7f0801" , color: "#fff" }} >Fee</th>
                                    <th className={`${styles.tableheading}`} style={{ backgroundColor: "#7f0801" , color: "#fff" }}>Schedule</th>
                                    <th className={`${styles.tableheading}`} style={{ backgroundColor: "#7f0801" , color: "#fff" }}>Payment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {feestructure3.map((item, index) => (
                                    <tr key={index}>
                                    <td className={`${styles.tablepara}`}>{item.center}</td>
                                    <td className={`${styles.tablepara}`}>{item.mode}</td>
                                    <td className={`${styles.tablepara}`}>{item.start}</td>
                                    <td className={`${styles.tablepara}`}>{item.fee}</td>
                                    <td className={`${styles.tablepara}`}>{item.cont3}</td>
                                    <td className="text-center align-middle">
                                        <a
                                        href="https://admissionsv1.shankariasacademy.com/"
                                        target="_blank"
                                        >
                                        <button
                                            className={`${styles.normalbutton1} btn btn-danger`}
                                        >
                                            Pay Now
                                        </button>
                                        </a>
                                    </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Mobile View */}
            <div className="d-md-none">
                {feestructure3.map((item, index) => (
                    <div key={index} className={`${styles.facultyborder3} row mb-3`}>
                    <div className="col-4 pt-2">Center</div>
                    <div className="col-8">{item.center}</div>

                    <div className="col-4 pt-2">Mode</div>
                    <div className="col-8">{item.mode}</div>

                    <div className="col-4 pt-2">Starts on</div>
                    <div className="col-8">{item.start}</div>

                    <div className="col-4 pt-2">Fee</div>
                    <div className="col-8">{item.fee}</div>

                    <div className="col-4 pt-2">Schedule</div>
                    <div className="col-8">{item.cont3}</div>

                    <div className="col-4 pt-2">Payment</div>
                    <div className="col-8">
                        <a
                        href="https://admissionsv1.shankariasacademy.com/"
                        target="_blank"
                        >
                        <button
                            className={`${styles.normalbutton1} btn btn-danger mt-2`}
                        >
                            Pay Now
                        </button>
                        </a>
                    </div>
                    </div>
                ))}
            </div>
        </div>
    </section>


 









<Interest />
<Footer />

        </>
    )
}

export default Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper2
